module.exports = __webpack_public_path__ + "img/XS-BOOST-footer.db80706e.jpg";